import { useApiClient } from '@/composables/useApiClient'

export const state = () => ({
  bookingData: {
    custNum: 0,
    bookingAt: '',
    bid: null,
    pid: null,
  },
  reservation: {
    status: 0,
    link_status: 0,
    branch: {},
    phone: '',
    booking_time: '',
    id: 0,
    note: '',
    nickname: '',
    gender: 0,
    cust_num: 1,
    email: '',
    product: null,
    duration: 0,
    link: '',
  },
})

export const getters = {
  bookingData: state => state.bookingData,
  reservation: state => state.reservation,
}

export const actions = {
  reserve({ commit }, reservationData) {
    const apiPath = '/reservations'
    return useApiClient()
      .$post(apiPath, reservationData)
      .then(res => {
        return res
      })
      .catch(error => {
        return error
      })
  },
  cancel({ commit }, { reservationId, data }) {
    const apiPath = `/reservations/${reservationId}/cancel`
    return useApiClient()
      .$post(apiPath, data, { platform: 'FunBook' })
      .then(res => {
        return res
      })
      .catch(error => {
        return error
      })
  },
  async getReservation({ commit }, reservationID) {
    const path = `/reservations/${reservationID}`
    const res = await useApiClient().$get(path, { platform: 'FunBook' })
    if (res.code === 0) {
      commit('SET_RESERVATION', res.data)
      return res.data
    }
  },
  setBookingData({ commit }, bookingData) {
    commit('SET_BOOKING_DATA', bookingData)
  },
  setStatus({ commit }, status) {
    commit('SET_STATUS', status)
  },
}

export const mutations = {
  SET_RESERVATION(state, reservation) {
    state.reservation = Object.assign({}, state.reservation, { ...reservation })
  },
  SET_STATUS(state, status) {
    state.reservation = Object.assign({}, state.reservation, {
      status: status,
    })
  },
  SET_BOOKING_DATA(state, bookingData) {
    state.bookingData = Object.assign({}, state.bookingData, {
      custNum: bookingData.custNum,
      bid: bookingData.bid,
      pid: bookingData.pid,
      bookingAt: bookingData.bookingAt,
    })
  },
}
